import * as React from "react";
import NavMenu from "./NavMenu";
import styled from "styled-components";
import Footer from "./Footer";
import { Backdrop as RawBackdrop, CircularProgress } from "@material-ui/core";
import LoggedOutAlert from "./LoggedOutAlert";
import { connect } from "react-redux";
import { IApplicationState } from "../store";
import Theme from "../Theme";
import { H3 } from "./Headers";

const FlexWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;

  & > * {
    flex: 1 auto;
  }
`;

const Backdrop = styled(RawBackdrop)`
  z-index: 3;
  flex-direction: column;
  color: ${Theme.colors.white};
  background-color: rgba(0, 0, 0, 0.7);

  transition: opacity 1s ease-in;

  &&& svg {
    color: ${Theme.colors.white};
  }
`;

const Content = styled.div`
  z-index: 0;
  min-height: calc(100vh - ${Theme.sizes.navHeight});
  padding-top: ${Theme.sizes.navHeight};

  @media all and (min-width: 800px) {
    & {
      flex: 3 0px;
    }
  }
`;

export interface ILayoutProps {
  isPending: boolean;
  pendingDescription?: string;
  children?: React.ReactNode;
  hideFooter: boolean;
}

const Layout = (props: ILayoutProps) => (
  <FlexWrapper>
    <NavMenu />
    <Content>{props.children}</Content>
    {!props.hideFooter && <Footer />}
    <Backdrop open={props.isPending}>
      <CircularProgress />
      <H3 center>{props.pendingDescription}</H3>
    </Backdrop>
    <LoggedOutAlert />
  </FlexWrapper>
);

export default connect((state: IApplicationState) => {
  return {
    isPending: state.status.isPending,
    pendingDescription: state.status.description,
  };
})(Layout);
